/**
 * Helper for rendering PDFs using VPS Iframe
 * 
 * Assumptions:
 * 
 * objectElem has class pdf-object and has a nested A tag with class pdf-object_fallback to be used
 * to click to download pdf in fallback case
 * 
 */
 export class RenderPdfObjectHelper {    
    /**
     * Constructor
     * @param {*} objectElem Element pointing to object html jquery element. Should have class pdf-object and have nested A tag with class pdf-object_fallback to download pdf in fallback case
     * @param {*} pdfUrl URL pointing to PDF document
     */
    constructor(objectElem, pdfUrl){
        this._ticking =  false;
        // Internet Explorer 6-11
        this._isIE = false;
        // Edge 20+
        this._isEdge = false;

        this._elem = objectElem;
        this._pdfUrl = pdfUrl;

        this._isIE= /*@cc_on!@*/false || !!document.documentMode;
        this._isEdge= !this._isIE && !!window.StyleMedia;

        // If this is not IE or Edge, load the iframe as usual on the page load.
        if (!this._isIE && !this._isEdge) {
            var iframeHtml = this._elem[0];
            if (iframeHtml != null && iframeHtml != undefined) {
                this.processIframeUrl();
            }
        }
    }
    /**
     * Functions
     */
    loadIframeContent(scroll_pos) {

        // Make sure to execute this once
        if (!this._ticking)
        {
           var hT = this._elem.offset().top,
           hH = this._elem.outerHeight(),
           wH = $(window).height(),
           wS = $(window).scrollTop() + 200;

           // Load the iframe content when the scroll position is on that section
           if (wS > (hT + hH - wH) && wS < (hT + hH + 900 - wH)) {
               if (this._elem != null && this._elem != undefined) {
                    this.processIframeUrl();
                    this._ticking = true;
               }
           }
        }
    }
    processIframeUrl() {
        var src = this._pdfUrl;
        //this._elem.attr("src", "");
        if (src != '') {
            this._elem.attr("data", src);
            var fallbackElem = $(this._elem.find(".pdf-object_fallback"))
            fallbackElem.attr("href", src);
        }
    }
};
